import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Stack, Button } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { getEmployerPositions } from '../../../apiconfig/api';
import { useSession } from '../../../context/SessionContext';
import { PositionsList } from './components';

const PositionsPage: React.FC = () => {
  const navigate = useNavigate();
  const { sessionEmployerId } = useSession();
  const [positions, setPositions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  const fetchPositions = async (pageNum = 1) => {
    if (!sessionEmployerId) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const resp = await getEmployerPositions(sessionEmployerId, {
        page: pageNum,
        per_page: 10
      }, true);
      
      setPositions(pageNum === 1 ? resp.data.employerPositions : [...positions, ...resp.data.employerPositions]);
      setHasMore(resp.data.hasMore || false);
    } catch (err: any) {
      setError(err.message || 'Failed to load positions.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessionEmployerId) {
      setPage(1);
      fetchPositions(1);
    }
  }, [sessionEmployerId]);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchPositions(nextPage);
  };

  const handleCreatePosition = () => {
    navigate('/hiring/post-job-workflow');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f4f4f4', py: 4 }}>
      <Container maxWidth="lg">
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 4 }}>
          <Typography level="h2" sx={{ fontWeight: 700 }}>
            Posts
          </Typography>
          
          <Button 
            variant="solid" 
            size="lg"
            onClick={handleCreatePosition}
          >
            Post a Job
          </Button>
        </Stack>
        
        <PositionsList
          positions={positions}
          loading={loading}
          error={error}
          page={page}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
        />
      </Container>
    </Box>
  );
};

export default PositionsPage; 